export const ACTIVITY_ICONS = {
  "laboratori-didattici": "FlaskConical",
  "visite-guidate": "Map",
  "animali": "Rabbit",
  "orto": "Sprout",
  "natura": "TreePine",
  "campi-estivi": "Tent",
  "feste-compleanno": "Cake",
  "pic-nic": "Utensils",
  "pranzo": "ChefHat",
  "genitori-bambini": "UsersRound",
};

export const ACTIVITY_LABELS = {
  "laboratori-didattici": "Laboratori didattici",
  "visite-guidate": "Visite guidate",
  "animali": "Animali in fattoria",
  "orto": "Orto e coltivazioni",
  "natura": "Escursioni in natura",
  "campi-estivi": "Campi estivi",
  "feste-compleanno": "Feste di compleanno",
  "pic-nic": "Pic Nic",
  "pranzo": "Pranzo in fattoria",
  "genitori-bambini": "Attività genitori-bambini",
};
